import { A } from "../report/sections/util";
import { WhitePage } from "./util";

const S = ({ children }) => (
  <a className="self-link" href={"#" + children} id={children}>
    {children}
  </a>
);

export const Terms = () => (
  <WhitePage>
    <div>
      <h2 className="text-3xl font-bold inline-block">Bodematlas</h2>
      <span className="pl-4 mb-10 text-gray-500">Algemene voorwaarden</span>
      <span className="float-right pr-5 pt-5">
        <A href="/static/Algemene voorwaarden Bodematlas.pdf">PDF</A>
      </span>
    </div>
    <div className="space-y-6 text-gray-800">
      <p className="font-semibold italic">Algemene voorwaarden Bodematlas B.V. per 8 juni 2025</p>

      <section>
        <h3 className="text-xl font-bold mb-2">
          <S>1.</S> Toepasselijkheid
        </h3>
        <ul className="list-none space-y-2">
          <li>
            <S>1.1</S> Deze voorwaarden zijn van toepassing op alle door Bodematlas B.V. gesloten
            overeenkomsten, door haar verstrekte offertes en door haar verleende diensten, tenzij
            nadrukkelijk en ondubbelzinnig door Bodematlas B.V. anders en schriftelijk aangegeven.
          </li>
          <li>
            <S>1.2</S> Opdrachtgever verklaart door ondertekening van de offerte van Bodematlas B.V.
            dan wel door acceptatie hiervan op enige andere wijze, expliciet kennis te hebben
            genomen of kennis te hebben kunnen nemen van deze voorwaarden en de volledige
            toepasselijkheid van deze voorwaarden te accepteren.
          </li>
          <li>
            <S>1.3</S> Afwijkingen van deze voorwaarden zijn slechts geldig wanneer dit schriftelijk
            en ondubbelzinnig schriftelijk (e-mail inbegrepen) is overeengekomen.
          </li>
          <li>
            <S>1.4</S> Deze voorwaarden gaan voor op eventuele voorwaarden die door opdrachtgever
            worden gehanteerd en door ondertekening van de offerte verklaart opdrachtgever expliciet
            afstand te doen van eventueel eigen voorwaarden, tenzij en voor zover partijen
            expliciet, nadrukkelijk en ondubbelzinnig schriftelijk (e-mail inbegrepen) anders zijn
            overeengekomen. Een eventueel eerder en/of vaker gebruik van eigen voorwaarden door
            opdrachtgever in verhouding tot Bodematlas B.V. doet aan vorenstaande niets af.
          </li>
          <li>
            <S>1.5</S> Bij tegenstrijdigheid van (de toepasselijkheid van de) voorwaarden prevaleren
            altijd de voorwaarden van Bodematlas B.V. waaronder begrepen de offerte zoals door
            Bodematlas B.V. verstrekt, boven de daarop verstuurde opdrachtbevestiging vanuit
            opdrachtnemer.
          </li>
        </ul>
      </section>

      <section>
        <h3 className="text-xl font-bold mb-2">
          <S>2.</S> Partijen
        </h3>
        <ul className="list-none space-y-2">
          <li>
            <S>2.1</S> Bodematlas B.V. is een onderneming die zich bezighoudt met;
            <ul className="list-[lower-alpha] ml-6 mt-2 space-y-1">
              <li>
                het verzamelen, bundelen en verstrekken van informatie met betrekking tot
                gebiedsontwikkeling (en bodeminformatie), waaronder begrepen doch niet beperkt tot
                voorbereidende en uitvoerende werkzaamheden, het verbinden van partijen binnen de
                zakelijke dienstverlening en het leveren van bijbehorende diensten en handel;
              </li>
              <li>
                het oprichten en verwerven en besturen van, het deelnemen in, het samenwerken met,
                alsmede het (doen) financieren van andere ondernemingen, in welke rechtsvorm ook;
              </li>
              <li>het verlenen van andere dan hiervoor bedoelde diensten;</li>
              <li>
                het verstrekken en aangaan van geldleningen, het beheren van en het beschikken over
                goederen, waaronder registergoederen, en het stellen van zekerheden, ook voor
                schulden van anderen;
              </li>
              <li>
                het uitvoeren van- en het verlenen van medewerking aan de uitvoering van
                lijfrenteovereenkomsten, andere inkomensvoorzieningen en kapitaalverzekeringen;
              </li>
              <li>
                het verrichten van alle verdere handelingen, die met het vorenstaande in de ruimste
                zin verband houden of daartoe bevorderlijk kunnen zijn.
              </li>
            </ul>
            <p className="mt-2">
              Het hoofdkantoor is gevestigd op het adres Jan Wolkerslaan 82, 9721MN Groningen.
              Bodematlas B.V. is ingeschreven in de Kamer van Koophandel onder nummer 9746792
              <S>8.</S> Meer informatie is te vinden op de website bodematlas.nl.
            </p>
          </li>
          <li>
            <S>2.2</S> Schriftelijke communicatie dient te worden gericht aan voormeld adres en/of
            per e-mail aan info@bodematlas.nl.
          </li>
          <li>
            <S>2.3</S> Onder opdrachtgever wordt verstaan elke partij met die Bodematlas B.V.
            overeenkomsten sluit en offertes aanvraagt.
          </li>
        </ul>
      </section>

      <section>
        <h3 className="text-xl font-bold mb-2">
          <S>3.</S> De opdracht
        </h3>
        <ul className="list-none space-y-2">
          <li>
            <S>3.1</S> De opdracht komt tot stand door expliciete ondertekening door opdrachtgever
            van de door Bodematlas B.V. verstrekte offerte of door schriftelijke acceptatie hiervan
            (e-mail inbegrepen), vorenstaande binnen de geldigheidsduur van de door Bodematlas B.V.
            verstrekte offerte zoals op die offerte vermeld of, als op de offerte geen
            geldigheidsduur staat vermeld, binnen uiterlijk 30 dagen na de datum waarop de offerte
            is verstrekt.
          </li>
          <li>
            <S>3.2</S> Indien tijdens de uitvoering van de overeenkomst blijkt dat voor een
            behoorlijke uitvoering het noodzakelijk is om de te verrichte werkzaamheden te wijzigen
            of aan te vullen, zullen partijen tijdig en in goed onderling overleg de overeenkomst
            dienovereenkomstig aanpassen.
          </li>
          <li>
            <S>3.3</S> Indien partijen overeenkomen dat de overeenkomst wordt gewijzigd of
            aangevuld, kan dit van invloed zijn op het tijdstip en/of de datum waarop de
            overeenkomst voltooid zou moeten zijn. Eventueel nadelige gevolgen hiervan komen in geen
            geval voor rekening en risico van Bodematlas B.V.
          </li>
          <li>
            <S>3.4</S> Een eventuele aanpassing van de opdracht dient ondubbelzinnig en expliciet
            schriftelijk (e-mail inbegrepen) te worden vastgelegd en geaccordeerd door beide
            partijen, met inbegrip van eventuele prijs- en datumconsequenties.
          </li>
        </ul>
      </section>

      <section>
        <h3 className="text-xl font-bold mb-2">
          <S>4.</S> Onvoorziene omstandigheden
        </h3>
        <p>
          Op verlangen van een der partijen kunnen de gevolgen van de opdracht worden gewijzigd of
          kan deze geheel of gedeeltelijk worden ontbonden op grond van onvoorziene omstandigheden,
          welke van dien aard zijn dat de wederpartij naar maatstaven van redelijkheid en
          billijkheid ongewijzigde instandhouding van de opdracht niet mag verwachten. Aan de
          wijziging of ontbinding kan terugwerkende kracht worden verleend.
        </p>
      </section>

      <section>
        <h3 className="text-xl font-bold mb-2">
          <S>5.</S> Inspanningsverplichting
        </h3>
        <p>
          Op Bodematlas B.V. rust bij de uitvoering van de overeenkomst een inspanningsverplichting,
          nadrukkelijk géén resultaatsverplichting tenzij expliciet en nadrukkelijk anders
          schriftelijk (e-mail inbegrepen) overeengekomen.
        </p>
      </section>

      <section>
        <h3 className="text-xl font-bold mb-2">
          <S>6.</S> Derden
        </h3>
        <ul className="list-none space-y-2">
          <li>
            <S>6.1</S> Het staat Bodematlas B.V. vrij om bij de uitvoering van de overeenkomst een
            beroep te doen op derden, zulks onverminderd de normale wettelijke verantwoordelijkheid
            van Bodematlas B.V. voor de deugdelijke uitvoering van de overeenkomst.
          </li>
          <li>
            <S>6.2</S> Indien Bodematlas B.V. op verzoek van opdrachtgever samenwerkt met één of
            meerdere derde(n), dan zal Bodematlas B.V. voor het door deze derde(n) verrichte deel
            van de overeenkomst niet verantwoordelijk en/of aansprakelijk zijn, tenzij en voor zover
            Bodematlas B.V. deze aansprakelijkheid nadrukkelijk en expliciet schriftelijk heeft
            aanvaard. Opdrachtgever draagt in die gevallen zorg voor de onderlinge coördinatie en is
            zelf (naast deze derde(n) zelf) verantwoordelijk voor de door deze derde(n) aan
            Bodematlas B.V. verstrekte gegevens en informatie.
          </li>
        </ul>
      </section>

      <section>
        <h3 className="text-xl font-bold mb-2">
          <S>7.</S> Verplichtingen en aansprakelijkheid van partijen
        </h3>
        <ul className="list-none space-y-2">
          <li>
            <S>7.1</S> De opdrachtgever gedraagt zich jegens Bodematlas B.V. als een goed en
            zorgvuldig opdrachtgever.
          </li>
          <li>
            <S>7.2</S> De opdrachtgever is gehouden om alle door Bodematlas B.V. verstrekte
            gegevens, rapporten en informatie vertrouwelijk en geheim te houden, waarbij het
            uitgangspunt is dat alle door Bodematlas B.V. verstrekte gegevens en informatie op welke
            manier dan ook vertrouwelijk zijn, tenzij en voor zover nadrukkelijk en expliciet anders
            door Bodematlas B.V. schriftelijk (e-mail inbegrepen) vermeld. Opdrachtgever is
            ongelimiteerd aansprakelijk voor alle schade die Bodematlas B.V. lijdt als gevolg van
            schending van deze geheimhouding.
          </li>
          <li>
            <S>7.3</S> De opdrachtgever is verantwoordelijk voor zowel de tijdige verstrekking als
            de juistheid van de door of namens haar aan Bodematlas B.V. verstrekte inlichtingen,
            gegevens en beslissingen die nodig zijn om de opdracht naar behoren te vervullen.
          </li>
          <li>
            <S>7.4</S> Opdrachtgever is verplicht om tijdig en schriftelijk (e-mail inbegrepen) aan
            Bodematlas B.V. mede te delen welke natuurlijke persoon of personen bevoegd zijn om de
            opdrachtgever te vertegenwoordigen, zo nodig onder vermelding van eventuele beperkingen
            in die bevoegdheid. Doet opdrachtgever dit niet, dan is opdrachtgever naast deze
            natuurlijke persoon/personen aansprakelijk voor alle eventueel hieruit voortvloeiende
            directe en indirecte schade aan de zijde van Bodematlas B.V.
          </li>
          <li>
            <S>7.5</S> De opdrachtgever vrijwaart Bodematlas B.V. volledig voor aanspraken van
            derden ter zake van alle door Bodematlas B.V. verstrekte inlichtingen, gegevens en
            verleende dienstverlening voortvloeiende uit de tussen partijen gesloten overeenkomst.
          </li>
          <li>
            <S>7.6</S> De opdrachtgever is verplicht Bodematlas B.V. direct en, zulks op verval van
            alle eventuele rechten en aanspraken jegens Bodematlas B.V. in ieder geval binnen
            uiterlijk 7 dagen schriftelijk en nadrukkelijk te waarschuwen indien hij bij of na de
            uitvoering van de overeenkomst een tekortkoming heeft geconstateerd of zich daarvan
            bewust heeft kunnen en/of had moeten zijn. Een eventuele tekortkoming moet
            ondubbelzinnig en concreet worden geduid met daarbij een concreet en ondubbelzinnig
            verzoek tot deugdelijke nakoming.
          </li>
          <li>
            <S>7.7</S> Opdrachtgever is verplicht om Bodematlas B.V. in de gelegenheid te stellen om
            bij een eventuele tekortkoming binnen een redelijke termijn (van tenminste 4 weken)
            nadat hierover is geklaagd, deze tekortkoming weg te nemen.
          </li>
          <li>
            <S>7.8</S> Opdrachtgever is verplicht om zelf een adequate en toereikende verzekering te
            hebben of af te sluiten. In die verzekering zullen tevens Bodematlas B.V. alsmede de
            door Bodematlas B.V. in te schakelen derden worden opgenomen. Indien opdrachtnemer géén
            adequate of toereikende verzekering heeft afgesloten en dit niet nadrukkelijk en
            voorafgaand aan de totstandkoming van de overeenkomst schriftelijk (e-mail inbegrepen)
            aan Bodematlas B.V. meldt, en daar vervolgens géén schriftelijk (e-mail inbegrepen)
            akkoord op verkrijgt vanuit Bodematlas B.V., dan is opdrachtgever ongelimiteerd
            aansprakelijk voor alle gevolgen die voortvloeien uit het niet nakomen van deze
            verplichting.
          </li>
          <li>
            <S>7.9</S> Opdrachtgever draagt zijn opdrachtgeverschap niet geheel of gedeeltelijk over
            aan een ander zonder nadrukkelijke en expliciete toestemming van Bodematlas B.V.
          </li>
          <li>
            7.10 Indien ter uitvoering van de overeenkomst betreding van percelen noodzakelijk is,
            zal daarvoor door of vanwege de opdrachtgever toestemming worden verleend c.q. worden
            verkregen. Eventuele schade voor Bodematlas B.V. die voortvloeit uit het niet of niet
            tijdig verkrijgen van toestemming komt ongelimiteerd voor rekening van opdrachtgever.
          </li>
          <li>
            7.11 Bodematlas B.V. is niet aansprakelijk voor schade, welke vorm dan ook, aan
            eigendommen van opdrachtgever of derden ontstaan, tijdens of in verband met uitvoering
            van haar werkzaamheden, tenzij er sprake is van opzet of grove schuld aan de zijde van
            Bodematlas B.V.
          </li>
          <li>
            7.12 De eventuele aansprakelijkheid van Bodematlas B.V. is beperkt tot directe schade en
            tot maximaal de hoogte van de opdrachtsom zoals overeengekomen in de overeenkomst, de
            deelovereenkomst of wijzigingsovereenkomst welk maximum het bedrag van € 250.000,- of in
            ieder geval de in de verzekering van Bodematlas B.V. vermelde som niet zal overstijgen.
          </li>
          <li>
            7.13 Bodematlas B.V. is niet aansprakelijk voor indirecte schade, onvoorzienbare en/of
            gevolgschade (zoals onder andere gederfde inkomsten en winsten, productieverlies,
            financierings- en advieskosten, verlies van klanten, verlies of beschadiging van
            gegevens, verlies van overeenkomsten, goodwill, supplementaire kosten, kosten die
            gemaakt zouden zijn als de opdracht van meet af aan juist zou zijn verricht).
          </li>
          <li>
            7.14 Opdrachtgever vrijwaart Bodematlas B.V. en de door haar ingezette medewerkers en
            derden voor aanspraken van derden verband houdend met de uitvoering van de overeenkomst.
          </li>
          <li>
            7.15 Opdrachtgever zorgt ervoor dat Bodematlas B.V. dan wel de door haar ingeschakelde
            derde(n) het werkterrein tijdig en veilig kunnen betreden, waarbij the werkzaamheden
            eveneens veilig en verantwoord uitgevoerd kunnen worden, tenzij expliciet en
            nadrukkelijk anders overeengekomen.
          </li>
          <li>
            7.16 Indien opdrachtgever ten behoeve van de uitvoering van de overeenkomst en/of het
            opstellen van de offerte door Bodematlas B.V. gegevens onvolledig, niet actueel of
            verkeerd aanlevert, terwijl die gegevens wel van belang zijn voor een goede uitvoering
            van de overeenkomst, is opdrachtgever aansprakelijk voor alle kosten die hieruit (direct
            en indirect) voortvloeien, met inbegrip van eventuele schade.
          </li>
          <li>
            7.17 Opdrachtgever is uitsluitend bevoegd om door Bodematlas B.V. verstrekte
            rapportages, documenten en informatie aan derden te verstrekken indien dit nadrukkelijk
            en ondubbelzinnig schriftelijk (e-mail inbegrepen) door Bodematlas B.V. is geaccordeerd
            en in dat kader aansprakelijk voor alle directe en indirecte schade die Bodematlas B.V.
            lijdt indien verstrekking aan derden geschiedt zonder deze expliciete toestemming.
          </li>
        </ul>
      </section>

      <section>
        <h3 className="text-xl font-bold mb-2">
          <S>8.</S> Tarieven en betaling
        </h3>
        <ul className="list-none space-y-2">
          <li>
            <S>8.1</S> Betaling van door Bodematlas B.V. verstrekte (deel)facturen zullen door
            opdrachtgever binnen uiterlijk 30 dagen na de factuurdatum worden betaald, tenzij er op
            de factuur een andere betaaltermijn staat vermeld.
          </li>
          <li>
            <S>8.2</S> Opdrachtgever raakt, zodra de betalingstermijn is verstreken, direct in
            verzuim en naast wettelijke handelsrente over het nog openstaande bedrag, te berekenen
            tot aan de dag van volledige betaling, tevens incassokosten verschuldigd zonder dat deze
            expliciet aangezegd hoeven te worden. De hoogte van deze incassokosten is in lijn met-
            en overeenkomstig het Besluit vergoeding voor buitengerechtelijke incassokosten’ (15%
            van de hoofdsom over de eerste € 2.500,- (met een minimum van € 40,-), 10% van de
            hoofdsom over de volgende € 2.500,- van de vordering, 5% van de hoofdsom over de
            volgende € 5.000,- van de vordering, 1% van de hoofdsom over de volgende € 190.000,- van
            de vordering, 0,5% over het meerdere van de hoofdsom met een maximum van € 6.775,-).
          </li>
          <li>
            <S>8.3</S> Bodematlas B.V. is gerechtigd tussentijdse prijsverhogingen als gevolg van
            gewijzigde wet- en regelgeving (waaronder begrepen belastingen) volledig aan
            opdrachtnemer door te berekenen.
          </li>
          <li>
            <S>8.4</S> Eventueel andere tussentijdse prijswijzigingen zullen aan opdrachtnemer
            worden doorbelast voor zover dit redelijk en billijk is en wettelijk toegestaan.
          </li>
        </ul>
      </section>

      <section>
        <h3 className="text-xl font-bold mb-2">
          <S>9.</S> Nietigheid
        </h3>
        <ul className="list-none space-y-2">
          <li>
            <S>9.1</S> Indien één of meerdere bepalingen uit deze voorwaarden of de overeenkomst
            nietig blijken te zijn of door de rechter worden vernietigd, behouden alle overige
            bepalingen van de voorwaarden en/of de overeenkomst hun rechtskracht. Partijen zullen
            over de nietige of vernietigde voorwaarde(n) en/of bepaling(en) overleg voeren teneinde
            (indien dit redelijkerwijs van partijen verlangd kan worden) een vervangende regeling te
            treffen.
          </li>
          <li>
            <S>9.2</S> Het nalaten om nakoming te vorderen van enig recht of enige bevoegdheid zal
            de rechten en bevoegdheden van Bodematlas B.V. niet aantasten of beperken, tenzij
            Bodematlas B.V. hier nadrukkelijk en schriftelijk (e-mail inbegrepen) heeft ingestemd.
          </li>
        </ul>
      </section>

      <section>
        <h3 className="text-xl font-bold mb-2">
          <S>10.</S> Toepasselijk recht
        </h3>
        <p>
          Op alle overeenkomsten, offertes en rechtsverhoudingen met Bodematlas B.V. is het
          Nederlandse recht van toepassing. Een eventueel geschil zal exclusief worden voorgelegd
          aan de bevoegde rechter van de rechtbank Groningen.
        </p>
      </section>
    </div>
  </WhitePage>
);
